var map = {
	"./AED.svg": 4032,
	"./ALL.svg": 27651,
	"./AMD.svg": 27640,
	"./ANG.svg": 76450,
	"./ARS.svg": 49874,
	"./AUD.svg": 90256,
	"./AZN.svg": 11839,
	"./BAM.svg": 26438,
	"./BBD.svg": 44338,
	"./BDT.svg": 73624,
	"./BGN.svg": 23035,
	"./BHD.svg": 61188,
	"./BMD.svg": 9331,
	"./BND.svg": 37014,
	"./BOB.svg": 78295,
	"./BRL.svg": 6010,
	"./BWP.svg": 62973,
	"./CAD.svg": 23266,
	"./CHF.svg": 12207,
	"./CLP.svg": 21541,
	"./CNY.svg": 53446,
	"./COP.svg": 39484,
	"./CRC.svg": 37408,
	"./CZK.svg": 99088,
	"./DJF.svg": 31318,
	"./DKK.svg": 97344,
	"./DOP.svg": 58623,
	"./EGP.svg": 61646,
	"./EUR.svg": 76818,
	"./GBP.svg": 56287,
	"./GEL.svg": 9458,
	"./GHS.svg": 30270,
	"./GTQ.svg": 79952,
	"./HKD.svg": 58747,
	"./HRK.svg": 4935,
	"./HUF.svg": 88287,
	"./IDQ.svg": 69478,
	"./IDR.svg": 5701,
	"./ILS.svg": 49708,
	"./INR.svg": 11671,
	"./IQD.svg": 4316,
	"./ISK.svg": 33461,
	"./JMD.svg": 7483,
	"./JOD.svg": 83665,
	"./JPY.svg": 80737,
	"./KES.svg": 40041,
	"./KGS.svg": 92799,
	"./KHR.svg": 1211,
	"./KRW.svg": 436,
	"./KWD.svg": 21696,
	"./KYD.svg": 27042,
	"./KZT.svg": 1420,
	"./LKR.svg": 78017,
	"./MAD.svg": 94144,
	"./MDL.svg": 40127,
	"./MGA.svg": 68679,
	"./MKD.svg": 89406,
	"./MNT.svg": 8069,
	"./MOP.svg": 64446,
	"./MUR.svg": 52618,
	"./MXN.svg": 2449,
	"./MYR.svg": 20006,
	"./MZN.svg": 63323,
	"./NAD.svg": 33227,
	"./NGN.svg": 37151,
	"./NOK.svg": 82106,
	"./NPR.svg": 5494,
	"./NZD.svg": 24422,
	"./OMR.svg": 80772,
	"./PAB.svg": 17919,
	"./PEN.svg": 23471,
	"./PGK.svg": 66952,
	"./PHP.svg": 90410,
	"./PKR.svg": 66381,
	"./PLN.svg": 3664,
	"./PYG.svg": 18394,
	"./QAR.svg": 73258,
	"./RON.svg": 69507,
	"./RSD.svg": 79045,
	"./RUB.svg": 94085,
	"./SAR.svg": 73036,
	"./SEK.svg": 78569,
	"./SGD.svg": 89736,
	"./SOS.svg": 72575,
	"./THB.svg": 55524,
	"./TRY.svg": 83033,
	"./TWD.svg": 93723,
	"./TZS.svg": 99723,
	"./UAH.svg": 64812,
	"./UGX.svg": 77558,
	"./USD.svg": 97934,
	"./UYU.svg": 41937,
	"./UZS.svg": 4918,
	"./VND.svg": 12706,
	"./XAF.svg": 41227,
	"./XOF.svg": 32621,
	"./XPF.svg": 55204,
	"./YER.svg": 71334,
	"./ZAR.svg": 36777,
	"./ZMW.svg": 4808
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6428;